export const blockIconsBusinessandpaymentsCreditCardNew = (
	<span className='material-symbols-outlined'>credit_card</span>
);
